export function keys(obj) {
    return _.keys(obj);
}

export function concatLists(list1, list2) {
    return list1.concat(list2);
}
